<script>

	import './style.scss'

	import {
		URL_PREFIX,
	} from '@/constants'

	export default {
		name: 'navigation',
		data: () => ({
			URL_PREFIX,
			blogPrefix: process.env.NODE_ENV === 'development' ? 'dev-blog' : 'blog'
		})
	}

</script>

<template>
	<div class='nav'>
		<div class='nav-container'>
			<div class='logo'>
				<a href='/'>
					<img class='full' src='/static/logo-full-white.svg'>
					<img class='head' src='/static/logo-head-white.svg'>
				</a>
			</div>
			<ul class='links'>
				<!--<li><a :href='`https://${blogPrefix}.techinterview.co`'>Blog</a></li>-->
				<li><a :href='`${URL_PREFIX}/login`'>Sign In</a></li>
			</ul>
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/Navigation/Navigation.vue